/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryOptions } from 'src/store/fetch-services';
import { VehicleModelEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  VehicleModelProps,
  VehicleModelViewModelBase,
} from 'src/store/generated/vehicle-model-record.generated';

export class VehicleModelViewModel extends VehicleModelViewModelBase {
  constructor(props: VehicleModelProps) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleModelViewModelService {
  constructor(private readonly _vehicleModelEntityFetchService: VehicleModelEntityFetchService) {}

  public getById(
    id: string,
    options?: QueryOptions,
  ): Observable<VehicleModelViewModel | undefined> {
    return this._vehicleModelEntityFetchService.getById(id, options).pipe(
      map((vehicleModel) => {
        if (vehicleModel == null) {
          return undefined;
        }
        return new VehicleModelViewModel(vehicleModel);
      }),
    );
  }
}
